import {Navigate} from 'react-router-dom';
import {getAuth} from 'firebase/auth';
/**
 * Wrapper component to protect a route to only be accessible by a logged-in user. Redirects un-logged-in users to /signin
 * @param {} children the route to protect 
 * @returns 
 */
export default function RequireAuth({children}) {
	const user = getAuth().currentUser;
	return user ? children : <Navigate to="/signin" replace />;
}
